
<template>
    <div class="number">
      <div id="okdata" class="oknumber">
        <app-header></app-header>
      <div id="oknumber_c" class="score_mumber">
        <div class="container">
          <div class="container_personal">
            <!--个人分类排序头部-->
            <h2>成长体系</h2>
            <div  class="zhibiao">
              <span  class="okrange">显示范围</span>
              <el-radio-group v-model="personal_score_radio" size="small"  @change="inipersonal_score_radio">
                <el-radio-button label="10">TOP 10</el-radio-button>
                <el-radio-button label="20">TOP 20</el-radio-button>
                <el-radio-button label="all">全部</el-radio-button>
              </el-radio-group>
            </div>
            <!--个人贡献-->
            <el-table :data="tablepersonalscoreData" style="width: 100%" :show-header="true" >
              <el-table-column type="index" label="排序" min-width="5%">  </el-table-column>
              <el-table-column prop="giteeId" label="Gitee名" min-width="20%">  </el-table-column>
              <el-table-column prop="okUsername" label="社区名" min-width="20%">  </el-table-column>
              <el-table-column prop="value" label="积分值" min-width="55%">
                <template slot-scope="tablepersonalscoreData">
                  <el-progress :text-inside="true" typeof="line" :stroke-width="24" :percentage="setpernalItemProgress(tablepersonalscoreData.row.value)" :format="setperItemText(tablepersonalscoreData.row.value)"></el-progress>
                </template>
            </el-table-column>
            </el-table>
          </div>
    </div>
    </div>
    </div>
    </div>
  </template>

  <script>
    import AppHeader from "./Header.vue"
    export default {
      name: 'Number',
      data() {
        return {
          personal_score_radio: "10",
          customColor: '#409eff',
          tablepersonalscoreData: [],
          pernal_max:0
        }

      },
      components: {
          AppHeader

        },
      created() {
        this.getpersonal_Data();
      },
      methods: {
        inipersonal_score_radio(value){
        this.personal_score_radio=value;
        this.getpersonal_Data();
         },
        setperItemText(row) {
          return () => {
            return row;
          }
        },

        // 得到个人中积分最大值
        setpernalItemProgress(data) {
          if (data >= this.pernal_max) {
            return 80
          } else {
            return parseInt((data / this.pernal_max).toFixed(1) * 80)||1
          }
        },
        // 个人的所有积分数据
        getpersonal_Data: function () {
          this.axios({
            method: 'get',
            url:  "https://dashboard-api.openkylin.top/api/data/member/score?top=" +  this.personal_score_radio
          }).then(repos => {
            this.tablepersonalscoreData = repos.data.data;
            this.pernal_max=  this.tablepersonalscoreData[0].value


          }).catch(function (error) {
            console.log(error);
          })
        },

      }

    }


  </script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>




  </style>




// WEBPACK FOOTER //
// src/components/Point.vue